import { Injectable } from '@angular/core';
import { IUserTokenPayload } from '@interfaces';
import { jwtDecode } from 'jwt-decode';
import { EventQueueService } from './event-queue.service';

/**
 * This service is used to manage the token directly. All token related operations
 * should be done through this service. This service is meant to import nothing to
 * avoid circular dependencies.
 */

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private eventQueue: EventQueueService) {}

  public storeToken(token: string) {
    localStorage.setItem('resplendent_token', token);
    this.eventQueue.dispatch('TOKEN_UPDATED', token);
  }

  public clearToken() {
    localStorage.removeItem('resplendent_token');
    this.eventQueue.dispatch('TOKEN_UPDATED', null);
  }

  public get token() {
    return localStorage.getItem('resplendent_token');
  }

  public get tokenObject(): IUserTokenPayload | null {
    const token = this.token;
    return token ? jwtDecode<IUserTokenPayload>(token) : null;
  }

  public get isValidToken() {
    return this.tokenObject?.exp > Date.now() / 1000;
  }
}
